<script module>
	export { OfficialLinkBtn };
</script>

<script lang="ts">
	import { generateOfficialLinks } from '$lib/utils/officialLinks.util';
	import type { Component } from 'svelte';
	import type { ClassValue } from 'svelte/elements';
	import IconLinkVariant from '~icons/mdi/link-variant';

	export interface OfficialLinkBtnProps {
		link: string;
		Icon: Component;
		text: string;
	}

	const {
		websiteUrl,
		facebookId,
		instagramId,
		unescoId
	}: {
		websiteUrl: string | undefined | null;
		facebookId: string | undefined | null;
		instagramId: string | undefined | null;
		unescoId: number | undefined | null;
	} = $props();

	const data = $derived<OfficialLinkBtnProps[]>(generateOfficialLinks({ websiteUrl, facebookId, instagramId, unescoId }));
</script>

{#if data.length > 0}
	<div class="card h-full w-full border border-base-content/5 bg-base-200/40 shadow-sm">
		<div class="card-body gap-6 p-6 md:p-8">
			<div class="flex flex-col justify-center gap-3 lg:flex-row">
				<h3 class="flex items-center gap-2 text-sm tracking-widest text-base-content/70 lg:mr-9">
					<IconLinkVariant />
					RESOURCES
				</h3>

				{#each data as props (props.text)}
					{@render OfficialLinkBtn({ props })}
				{/each}
			</div>
		</div>
	</div>
{/if}

{#snippet OfficialLinkBtn({ props, btnSizeClass = 'btn-md' }: { props: OfficialLinkBtnProps; btnSizeClass?: ClassValue })}
	<a
		class="btn {btnSizeClass} btn-ghost justify-start bg-base-100 shadow-sm hover:bg-base-300"
		href={props.link}
		target="_blank"
		rel="noopener"
	>
		<props.Icon class="shrink-0 text-primary" />
		{props.text}
	</a>
{/snippet}
